import React, { FunctionComponent, useRef } from 'react';
import { ZakekeViewer, useZakeke } from 'zakeke-configurator-react';
import './Viewer.css';
import Selector from '../../components/selector';

const Viewer: FunctionComponent<{}> = () => {
  const { isSceneLoading } = useZakeke();

  const viewElement = useRef<HTMLDivElement | null>(null);

  const fullScreen = () => {
    viewElement.current!.requestFullscreen();
  };

  return (
    <>
      <div className="layout">
        <>
          <div className="ff_root">
            <div className="ff_viewer">
              <div className="ff_viewer_right_actions"></div>
              <div className="ff_viewer_zakeke" ref={viewElement}>
                {!isSceneLoading && <ZakekeViewer bgColor="#f8f8f8" />}
              </div>
            </div>
          </div>
        </>
        <Selector refViewer={viewElement} fullScreen={() => fullScreen()} />
      </div>
    </>
  );
};

export default Viewer;
